import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PrivateChat from './PrivateChat';
import ChatArea from './ChatArea';
import { IMessage } from 'models';

interface Participant {
  id: string;
  name: string;
  fullname?: string;
  profilePhoto?: string;
  lastMessage?: IMessage;
}

const PrivateChatSwitch = ({item}) => { 
  const [toggle, setToggle] = useState(true);
  const [userData, setUserData] = useState(item?.users && item?.users[0]);
  // const [openPrivateChat, setOpenPrivateChat] = useState<Participant | null>(null);


  useEffect(() => {
    if (item?.type === 'private') {
      setUserData(item.userData); // all user data
      setToggle(false);
    }
  }, [item]);

  return (
    <div style={{ flex: 1 }}>
      {toggle ? (
        <PrivateChat />
      ) : (
        <ChatArea  animate="animate-fadeIn" room_id={item.room_id} userData={userData} itemData={item}  isPrivateChat={true}/>
      )}
    </div> 
  );
};

export default PrivateChatSwitch;
